// extracted by mini-css-extract-plugin
export var center = "_5t-2";
export var clickableRow = "_5t-5";
export var expandedRow = "_5t-7";
export var hoverable = "_5t-4";
export var left = "_5t-1";
export var right = "_5t-3";
export var row = "_5t-0";
export var selectedRow = "_5t-6";
export var summaryRow = "_5t-8";